import alt from '../alt';
import Immutable from 'seamless-immutable';
import {seamlessImmutable, seamlessBootstrap} from 'epic-alt-utils/index';

@seamlessImmutable
class HomeStore {
    constructor() {
        this.on('error', (error) => {console.error(error);});
        this.on('bootstrap', seamlessBootstrap.bind(this, null));
        this.state = Immutable({
            cmsData: {}
        });
    }
}

export default alt.createStore(HomeStore, 'HomeStore');
